import { type FC } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppContent from './AppContent';
import DevHeader from '@Components/common/dev-header/DevHeader';
import { isLocal } from '@Shared/env/env';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const App: FC = () => {
  if (!isLocal) {
    return (
      <div id="crew-hub__main" translate="no">
        <QueryClientProvider client={queryClient}>
          <AppContent />
        </QueryClientProvider>
      </div>
    );
  }

  return (
    <>
      <header style={{ position: 'sticky', top: 0, zIndex: 999 }}>
        <DevHeader />
      </header>
      <main>
        <div id="crew-hub__main" translate="no">
          <QueryClientProvider client={queryClient}>
            <AppContent />
          </QueryClientProvider>
        </div>
      </main>
    </>
  );
};

export default App;
